import React from "react";
import "./UaeBlore.css";

const UaeBloreHead = (props) => {
  return (
    <div className="uaeBloreHead">
      <h2>{props.head}</h2>
    </div>
  );
};

export default UaeBloreHead;
